export default __webpack_public_path__ + "static/media/header-logo.82cc2615.png";